export const extractDateFieldname = (str: string) => {
  const result = str.replace(/_(before|after):.*$/, '');
  return result;
};
